module.exports = __webpack_public_path__ + "static/media/O65-1000_in.97f18177.jpg";